export default __webpack_public_path__ + "static/media/Rectangle61.ed70ce2a.png";